import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import aboutImg from "../../assets/img2.png";

const stats = [
  { val: "500+", label: "Klientë të Trajtuar" },
  { val: "5+", label: "Vite Eksperiencë" },
  { val: "8+", label: "Trajtime Premium" },
  { val: "98%", label: "Kënaqësi e Klientëve" },
];

const About = () => {
  return (
    <Section id="about">
      <Inner>
        <LeftCol>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          >
            <Label>Kush Jemi</Label>
            <Title>
              Beauty is a<br />
              <em>Science.</em>
              <br />
              We speak it
              <br />
              fluently.
            </Title>
          </motion.div>
          <StatsRow>
            {stats.map((s, i) => (
              <Stat
                key={s.label}
                as={motion.div}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.7,
                  delay: i * 0.1,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <StatVal>{s.val}</StatVal>
                <StatLabel>{s.label}</StatLabel>
              </Stat>
            ))}
          </StatsRow>
        </LeftCol>

        <RightCol>
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          >
            <ImageWrap>
              <AboutImg src={aboutImg} alt="Elaia Aesthetic Studio" />
              <ImageAccent />
            </ImageWrap>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          >
            <TextBlock>
              <Para>
                Elaia Aesthetic u krijua nga një besim i vetëm: që çdo person
                meriton akses në ekspertizën e kujdesit të lëkurës me nivel
                mjekësor, të ofruar me ngrohtësi, precizion dhe kujdes të
                vërtetë.
              </Para>
              <Para>
                Klinika jonë kombinon teknologjinë më të fundit estetike — nga
                sistemi Zemits DermeLuxx Pro i hidrodermabrazionit deri tek pena
                e mikroneedling Dr. Pen A11 Ultima PRO — me protokolle trajtimi
                thellësisht individuale.
              </Para>
              <Para>
                Ne nuk bëjmë trajtim të njëjtë për të gjithë. Ne bëjmë{" "}
                <em>ty</em>.
              </Para>
            </TextBlock>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.35 }}
          >
            <PhilosophyCard>
              <PhilosophyQ>"</PhilosophyQ>
              <PhilosophyText>
                Rezultate reale. Pa kompromise. Lëkura jote meriton më të mirën
                që shkenca mund të ofrojë.
              </PhilosophyText>
              <PhilosophyAuthor>— Elaia, Themeluese</PhilosophyAuthor>
            </PhilosophyCard>
          </motion.div>
        </RightCol>
      </Inner>
    </Section>
  );
};

const Section = styled.section`
  background: var(--charcoal-soft);
  padding: 140px 0;
  position: relative;
`;
const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 60px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  align-items: start;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;
const LeftCol = styled.div`
  position: sticky;
  top: 120px;
  @media (max-width: 1024px) {
    position: relative;
    top: auto;
  }
`;
const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;
const Label = styled.span`
  display: block;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--rose);
  margin-bottom: 28px;
`;
const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(44px, 5.5vw, 80px);
  font-weight: 300;
  color: var(--cream);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 64px;
  em {
    font-style: italic;
    color: var(--rose);
  }
`;
const StatsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
`;
const Stat = styled.div`
  border-top: 1px solid rgba(196, 149, 122, 0.2);
  padding-top: 20px;
`;
const StatVal = styled.div`
  font-family: var(--font-display);
  font-size: clamp(36px, 4vw, 52px);
  font-weight: 300;
  color: var(--rose);
  letter-spacing: -0.02em;
  line-height: 1;
  margin-bottom: 8px;
`;
const StatLabel = styled.div`
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--taupe);
`;
const ImageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 520px;
  overflow: hidden;
  border: 1px solid rgba(196, 149, 122, 0.1);
`;
const AboutImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  filter: brightness(0.9) saturate(0.9);
  transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);
  ${ImageWrap}:hover & {
    transform: scale(1.04);
  }
`;
const ImageAccent = styled.div`
  position: absolute;
  bottom: -16px;
  right: -16px;
  width: 120px;
  height: 120px;
  border: 1px solid rgba(196, 149, 122, 0.25);
  pointer-events: none;
`;
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Para = styled.p`
  font-family: var(--font-body);
  font-size: 16px;
  font-weight: 300;
  color: var(--taupe);
  line-height: 1.85;
  margin: 0;
  em {
    font-style: italic;
    color: var(--cream);
  }
`;
const PhilosophyCard = styled.div`
  border-left: 2px solid var(--rose);
  padding: 24px 32px;
  background: rgba(196, 149, 122, 0.04);
`;
const PhilosophyQ = styled.span`
  display: block;
  font-family: var(--font-display);
  font-size: 48px;
  color: var(--rose);
  line-height: 0.5;
  margin-bottom: 16px;
  opacity: 0.6;
`;
const PhilosophyText = styled.p`
  font-family: var(--font-display);
  font-size: clamp(18px, 2vw, 22px);
  font-style: italic;
  font-weight: 300;
  color: var(--cream);
  line-height: 1.6;
  margin: 0 0 16px;
`;
const PhilosophyAuthor = styled.span`
  font-family: var(--font-body);
  font-size: 11px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--rose);
`;

export default About;
